const styles = theme => ({
  root: {
    height: "100vh",
    backgroundColor: "#fffcf1",
  },
  paper: {
    position: "relative",
    minHeight: 300,
    padding: 20,
  },
  loader: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  error: {
    color: "red",
    textAlign: "center",
  }
});
export default styles;